import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const IconMove = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 5.623l1.688-1.688 1.687 1.688m0 10.125l-1.688 1.687L9 15.748m1.688-11.813v13.5m5.062-8.437l1.688 1.687-1.688 1.688m-10.125 0l-1.688-1.688 1.688-1.687m11.813 1.687h-13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M.563.56l2.386 6.365L4.142 4.14l2.784-1.193L.562.56z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconMove;
